import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { AuthService } from 'src/app/core/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class TokenInterceptor implements HttpInterceptor {
  constructor(private auth: AuthService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    // Public endpoints that must NOT carry an Authorization header.
    const bypassUrls = [
      '/auth/login',
      '/auth/register',
      '/auth/activate',
      '/auth/verify',
      '/auth/resend-verification',
      '/users/password',
    ];

    if (bypassUrls.some(url => request.url.endsWith(url))) {
      return next.handle(request);
    }
    if (this.auth.tokenIsSet) {
      const token = this.auth.token;
      if (token) {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        });
      }
    }

    return next.handle(request).pipe(
      catchError((err) => {
        if (err.status === 401) {
          if (!bypassUrls.some(url => request.url.endsWith(url))) {
            this.auth.logout();
          }
        }
        return throwError(() => err);
      })
    );
  }
}
